import { Component, Input, OnInit } from '@angular/core';
import { handleRatio } from 'src/app/_classes';
import { GeneratedTimelineCardData, Sponsor } from 'src/app/_interfaces';
import { VideoAdsService } from 'src/app/_services';
import { StandloneArrayComponent } from './standlone-array/standlone-array.component';
import { ContributedArticlesCardComponent } from './contributed-articles-card/contributed-articles-card.component';
import { FollowPlayersCardComponent } from './follow-players-card/follow-players-card.component';
import { CombinedSocialCardComponent } from './combined-social-card/combined-social-card.component';
import { RotatingSponsorsComponent } from './rotating-sponsors/rotating-sponsors.component';
import { SocialFeedCardComponent } from './social-feed-card/social-feed-card.component';
import { FeedSubjectCardComponent } from './feed-subject-card/feed-subject-card.component';
import { SponsorBannerComponent } from '../sponsor-banner/sponsor-banner.component';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';

@Component({
    selector: 'app-timeline-component',
    templateUrl: './timeline-component.component.html',
    styleUrls: ['./timeline-component.component.scss'],
    imports: [StandloneArrayComponent, ContributedArticlesCardComponent, FollowPlayersCardComponent,
        CombinedSocialCardComponent, RotatingSponsorsComponent, SocialFeedCardComponent, FeedSubjectCardComponent,
        SponsorBannerComponent]
})
export class TimelineComponentComponent implements OnInit {

    @Input() timeline_item!: GeneratedTimelineCardData;
    @Input() timeline_id!: string;

    public loggedIn = this.ssr.isLoggedIn();
    public aspect_ratio: string = '';
    public video_ad_sponsor: Sponsor | null = null;

    constructor(
        private videoAdAPI: VideoAdsService,
        private ssr: SsrlocalstoreService
    ) { }

    ngOnInit(): void {
        this.videoAdAPI.videoAdSponsor.subscribe((sponsor) => this.overrideSponsorBanner(sponsor!));

        this.overrideSponsorBanner(this.videoAdAPI.get__videoAd()?.[0]?.sponsor);

        this.aspect_ratio = this.timeline_item.card_type === 'sponsor' ? handleRatio(this.timeline_item) : '';

        return;
    }

    overrideSponsorBanner(sponsor: Sponsor): void {
        if (sponsor?.id) {
            this.video_ad_sponsor = sponsor;
        } else {
            this.video_ad_sponsor = null;
        }
    }
}
